import * as buttonText from './ui-button-text.js'

export default async function procDeal(params) {
    const { app, w, h, cards } = params;

    // Move pile of cards
    let x = w * 0.09;
    let y = h * 0.24;
    const pArr = cards.map((card, i) => {
        y -= 2;
        return anime({targets: card, x, y, easing: 'linear', duration: 500}).finished;
    });
    await Promise.all(pArr);

    // Deal cards
    const cards4 = cards.slice(-4).reverse();
    for (let i = 0; i < cards4.length; i ++) {
        const card = cards4[i];
        const x = w * [0.28, 0.72, 0.5, 0.5][i];    // left, right, bottom, top
        const y = h * [0.5, 0.5, 0.68, 0.32][i];    // left, right, bottom, top
        await anime({targets: card, x, y, easing: 'linear', duration: 500}).finished;
    }

    // Show button
    const text = '占い結果を見る';
    await new Promise(resolve => {
        const button = buttonText.gen(app, text, async () => {
            button.destroy();
            resolve();
        });
        button.y = h * 0.9;
        button.zIndex = 100;
    });

    // Show cards
    for (let i = 0; i < cards4.length; i ++) {
        const card = cards4[i];
        const s = card.__scale * 1.5;
        await anime({targets: card.scale, x: s, y: s, easing: 'linear', duration: 500}).finished;

        if (! card.__isUpright) card.rotation = Math.PI;
        card.setSide(true);
    }

    params.cards4 = cards4;
}